import { Type } from '@angular/core';
import { Client } from './client.model';
import { ShiftRecord } from './shift-record.model';
import { WorkflowPage } from './workflow-page.model';

export class AncillaryWorkflowPage extends WorkflowPage { 
    unitOfServiceName: string;
    isLastShiftBlock: boolean;
    
    public constructor(public component: Type<any>, public shiftRecord: ShiftRecord, public client: Client, fields?: Partial<AncillaryWorkflowPage>) {
        super(component, shiftRecord, client, fields);
        if (fields) {
            this.unitOfServiceName = fields.unitOfServiceName;
            this.isLastShiftBlock = fields.isLastShiftBlock;
        }
    }
}